import React from 'react'
import { useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { AiOutlineMinus } from 'react-icons/ai'
import './testimonials.css'

const FAQ = ({question,answer}) => {
  const [isAnswerShowing,setIsAnswerShowing] = useState(false)
  return (

    <article className='faq' onClick={()=> setIsAnswerShowing(prev=>!prev)}>
        <div>
            <h4 className='Faqs-white'>{question}</h4>
            <button className='faq__icon'>
              {
                isAnswerShowing? <AiOutlineMinus/> :<AiOutlinePlus/>
              }
              </button>
        </div>
        {isAnswerShowing && <p className='Faqs-white'>{answer}</p>}
    </article>

  )
}

export default FAQ